import { CollectionName } from '../../constants';
import { MigrationType } from '../types';

const TYPES_TO_REMOVE = ['USER_DETAILS', 'PERSONAL_CONTACTS', 'OWN_ID'];

const migrate: MigrationType['migrate'] = (data) => {
  const personalIdentifiers = data.get(CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS);
  if (!personalIdentifiers?.size) return data;

  const updatedPersonalIds = new Map(personalIdentifiers);
  personalIdentifiers.forEach((item, id) => {
    if (typeof item.personalIdentifierType !== 'string') return;

    if (TYPES_TO_REMOVE.includes(item.personalIdentifierType)) {
      updatedPersonalIds.delete(id);
    }
  });

  const result = new Map(data);
  result.set(CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS, updatedPersonalIds);

  return result;
};

export const migration18: MigrationType = {
  migrate,
  version: 19,
};
